/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { UpdateFamilyMemberPayload } from 'api/actions/update-family-member/update-family-member-payload';
import { UpdateFamilyMemberPathParameters } from 'api/actions/update-family-member/update-family-member-path-parameters';
import { UpdateFamilyMemberResponse } from 'api/actions/update-family-member/update-family-member-response';

type UpdateFamilyMemberQueryParameters = Record<string, any>;

/**
 * The path of the UpdateFamilyMember action.
 */
export const updateFamilyMemberActionPath = new SweetPath<keyof UpdateFamilyMemberPathParameters>(
  '/user/family/members/{userId}/update',
  { path: '{param}' }
);

/**
 * Creates a contextualized UpdateFamilyMember actions.
 */
export default function createUpdateFamilyMemberAction(axios: AxiosInstance) {
  return function updateFamilyMemberAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: UpdateFamilyMemberPathParameters;
    query?: UpdateFamilyMemberQueryParameters;
    payload: UpdateFamilyMemberPayload;
  }) {
    const path = updateFamilyMemberActionPath.insert(parameters);

    return axios.put<UpdateFamilyMemberResponse, UpdateFamilyMemberResponse, UpdateFamilyMemberPayload>(path, payload);
  };
}
